<template>
  <div style="margin-top: 50px">
    <popup :message="alertErrMessage" v-if="isAlertErr" :isError="isError" @close="isAlertErr = false" />
    <div style="background-color: #162ca2">
      <v-img src="/img/corporate/tech-main.png" height="100%"></v-img>
    </div>
    <v-col style="background-color: #162ca2; padding: 25px 32px 20px 32px">
      <div class="lg-heading">
        {{ $t('corporateTraining.heroSection.title') }}
      </div>
      <v-spacer style="height: 25px" />
      <div class="lg-content">
        {{ $t('corporateTraining.heroSection.description') }}
      </div>
      <v-spacer style="height: 25px" />
      <v-btn block class="btn" style="color: #162ca2; background-color: #ffde59" elevation="0"
        @click="scrollToSection('collab_training')">
        {{ $t('corporateTraining.heroSection.ctaButtons.collaborateNow') }}
      </v-btn>
      <v-spacer style="height: 10px" />
      <v-btn block class="btn" elevation="0" @click="sendToWa">
        {{ $t('corporateTraining.heroSection.ctaButtons.contactUs') }}
      </v-btn>
      <v-spacer style="height: 20px" />
    </v-col>
    <div style="background: linear-gradient(to bottom, #162ca2, #ffffff)">
      <v-col style="
          border-radius: 26px 26px 0px 0px;
          background-color: #ffffff;
          gap: 40px;
          padding: 37px 32px 40px 32px;
        ">
        <div class="md-heading">
          {{ $t('corporateTraining.trustedPartners.title') }}
        </div>
        <v-spacer style="height: 20px" />
        <div class="d-flex overflow-x-hidden overflow-y-hidden" style="height: 100%">
          <v-col cols="6" v-for="(data, idx) in partners" :key="idx" class="
              d-flex
              justify-content-center
              align-content-center
              scroll-container
            ">
            <v-img :src="data.img_url_mobile" contain />
          </v-col>
        </div>
        <v-spacer style="height: 40px" />
        <div class="md-heading">{{ $t('corporateTraining.services.title') }}</div>
        <v-spacer style="height: 10px" />
        <div class="md-content" style="text-align: center">
          {{ $t('corporateTraining.services.description') }}
        </div>
        <div class="list-service">
          <div v-for="(data, index) in $t('corporateTraining.courseOffer')" :key="index" class="data">
            <div>
              <img :src="data.img" alt="" style="width: 54px; height: 54px; border-radius: 100%">
            </div>
            <div style="display: flex; flex-direction: column; gap: 0.2rem">
              <div style="font-weight: 750; font-size: 1rem">
                {{ data.title }}
              </div>
              <div style="font-size: 0.8rem; text-align: justify">
                {{ data.desc }}
              </div>
            </div>
          </div>
        </div>
      </v-col>
      <v-col style="
          background: linear-gradient(to bottom, #ffffff, #f1f6ff);
          padding: 40px 32px;
          border-radius: 0px 0px 26px 26px;
        ">
        <div>
          <div class="md-heading">
            {{ $t('corporateTraining.course.title') }}
          </div>
          <v-spacer style="height: 10px" />
          <div class="md-content" style="text-align: center; font-size: 15px">
            {{ $t('corporateTraining.course.description') }}
          </div>
          <v-spacer style="height: 20px" />
          <v-tabs grow style="border-bottom: 1px solid #d3d6e1" v-model="program">
            <v-tab v-for="item in programTabs" :key="item.value" :value="item.value" @click="chooseTab(item)" style="
                width: 125px;
                letter-spacing: normal;
                text-transform: capitalize;
                font-size: 14px;
                line-height: 18px;
              ">
              {{ item.title }}
            </v-tab>
          </v-tabs>
          <v-window v-model="program" :touch="{ left: swipeLeft, right: swipeRight }" style="padding: 16.5px 0">
            <v-window-item v-for="index in programTabs.length" :key="index.value">
              <v-col v-for="(data, idx) in courseMaterial" :key="idx">
                <div class="program-card-header">
                  <MessageIcon :width="22" :height="22" />
                  {{ data.title }}
                </div>
                <div class="program-card-content">
                  {{ data.description }}
                  <v-spacer style="height: 10px"></v-spacer>
                  <b>{{ $t('corporateTraining.course.scopeLearning') }}</b>
                  <ul>
                    <li v-for="(item2, idx2) in data.scope_learning" :key="idx2">
                      {{ item2.name }}
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-window-item>
          </v-window>
        </div>
        <div class="consultation-card">
          <div class="md-heading" style="font-size: 15.5px; font-weight: 700; line-height: 22px">
            {{ $t('corporateTraining.course.cta.notFound') }}
          </div>
          <div class="lg-content" style="color: #36373f; font-weight: 400; font-size: 14px"
            v-html="$t('corporateTraining.course.cta.consultation')">
          </div>
          <v-btn class="btn" style="background-color: #162ca2; color: #ffffff" block @click="sendToWaConsultation">
            {{ $t('corporateTraining.course.cta.button') }}
          </v-btn>
        </div>
      </v-col>
    </div>
    <div style="padding: 40px 32px">
      <div class="md-heading text-center" style="font-size: 20px">
        {{ $t('corporateTraining.whyChoose2.title') }}
      </div>
      <v-spacer style="height: 6px"></v-spacer>
      <div class="md-content text-center" style="font-size: 16px; line-height: 25px"
        v-html="$t('corporateTraining.whyChoose2.description')"></div>
      <v-spacer style="height: 20px" />
      <div style="gap: 20px">
        <v-col style="padding: 12px 0" v-for="(data, index) in $t(`corporateTraining.whyChoose`)" :key="index" :style="{
          gap: '10px',
          borderBottom:
            index === $t(`corporateTraining.whyChoose`).length - 1 ? 'none' : '1px solid #acafbf',
        }">
          <v-spacer style="height: 10px"></v-spacer>
          <img :src="`/img/corporate/w-${index + 1}.png`" alt="aaa"
            style="width: 42px; height: 42px; border-radius: 100%" />
          <v-spacer style="height: 5px"></v-spacer>
          <div class="sm-heading" style="font-size: 15px">
            {{ data.title }}
          </div>
          <v-spacer style="height: 10px"></v-spacer>
          <div class="sm-content" style="text-align: justify; font-size: 13px">
            {{ data.desc }}
          </div>
          <v-spacer style="height: 10px"></v-spacer>
        </v-col>
        <v-img src="/img/corporate/tech/main-2.png" aspect-ratio="1" style="border-radius: 16px" />
      </div>
      <v-spacer style="height: 40px" />
    </div>
    <StepCollaborationMobile :title="$t(`corporateTraining.a1`)" :steps="$t(`corporateTraining.steps`)" />
    <div style="margin-top: 30px" class="partner">
      <div class="md-heading mb-4" style="font-size: 20px">
        {{ $t(`corporateTraining.a2`) }}
      </div>
      <div v-for="(i, idx) in dataMitra" :key="idx" style="overflow-x: scroll; display: flex; gap: 40px; width: 100%">
        <div v-if="idx === partnerModel" class="Partner">
          <div class="logo">
            <v-img :src="$utils.loadImage(i.image_url)" height="150" width="150" />
          </div>
          <v-spacer style="height: 20px"></v-spacer>
          <div class="alibaba-title">{{ i.name }}</div>
          <v-spacer style="height: 10px"></v-spacer>
          <div class="alibaba-content text-justify">
            {{ i.description }}
          </div>
        </div>
      </div>
    </div>
    <!-- Pagination -->
    <v-row style="margin: 20px 0px 20px 0px; padding: 0px 20px; width: 100%" class="d-flex align-center">
      <v-col cols="8">
        <div class="slider">
          <div class="indicator" :style="{
            width: `${sliderIndicatorPartner}%`,
            transform: `translateX(${indicatorValuePartner}%)`,
            transition: `transform 0.5s`,
          }"></div>
        </div>
      </v-col>
      <v-col cols="4" class="d-flex" style="justify-content: flex-end; gap: 11px">
        <v-btn v-for="index in 2" fab :key="index" @click="index === 1 ? PartnersPrev() : PartnersNext()"
          class="btn-mobile-slider-corp" elevation="0">
          <ArrowIcon style="color: white" :direct="index === 1 ? 'right' : 'left'" />
        </v-btn>
      </v-col>
    </v-row>
    <div class="project">
      <h2>{{ $t(`corporateTraining.a3`) }}</h2>
      <div style="">
        <div v-for="(i, idx) in portfolios" :key="idx">
          <div v-if="idx === portfoliosModel">
            <div class="img-card">
              <img :src="$utils.loadImage(i.image_url)" alt="" height="400" />
            </div>
            <div class="card-port">
              <div class="content-port">
                <h2>{{ i.title }}</h2>
                <p class="type" v-if="i.label">
                  {{ i.label }}
                </p>
                <p class="short">{{ i.program }}</p>
                <p class="desc">{{ i.description }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Pagination -->
      <v-row style="margin: 0px 10px; padding: 0px 10px" class="d-flex align-center">
        <v-col cols="8">
          <div class="slider">
            <div class="indicator" :style="{
              width: `${sliderIndicatorPortfolios}%`,
              transform: `translateX(${indicatorValuePortfolios}%)`,
              transition: `transform 0.5s`,
            }"></div>
          </div>
        </v-col>
        <v-col cols="4" class="d-flex" style="justify-content: flex-end; gap: 11px">
          <v-btn v-for="index in 2" fab :key="index" @click.prevent="index === 1 ? PortfoliosPrev() : PortfoliosNext()"
            class="btn-mobile-slider-corp" elevation="0">
            <ArrowIcon style="color: white" :direct="index === 1 ? 'right' : 'left'" />
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="testimony">
      <h1>{{ $t(`corporateTraining.a4`) }}</h1>
      <v-window v-model="testimonyModel">
        <v-window-item v-for="index in testimony.length" :key="index" style="padding: 10px; height: 220px">
          <v-card v-for="(data, index) in slicedTestimony(testimonyModel)" :key="index" style="
              background-color: #ffffff;
              box-shadow: 2px 2px 10px 3px rgba(13, 28, 113, 0.1);
              border-radius: 16px;
              padding: 17px 20px;
              height: 190px;
            ">
            <v-row>
              <!-- Message -->
              <v-col cols="12">
                <div class="feedback">“{{ data.feedback }}”</div>
              </v-col>
              <!-- User -->
              <v-col cols="12">
                <v-row>
                  <!-- Image -->
                  <v-col cols="3">
                    <v-img :src="$utils.loadImage(data.image_url)" width="60" height="60" style="border-radius: 50%" />
                  </v-col>
                  <!-- Name and Position -->
                  <v-col cols="9">
                    <div style="font-size: 12px; font-weight: 700">
                      {{ data.name }}
                    </div>
                    <div style="font-size: 10px">
                      {{ data.job }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card>
        </v-window-item>
      </v-window>
      <!-- Pagination -->
      <v-row style="margin: 0px 10px; padding: 0px 10px" class="d-flex align-center">
        <v-col cols="8">
          <div class="slider">
            <div class="indicator" :style="{
              width: `${sliderIndicatorTestimony}%`,
              transform: `translateX(${indicatorValueTestimony}%)`,
              transition: `transform 0.5s`,
            }"></div>
          </div>
        </v-col>
        <v-col cols="4" class="d-flex" style="justify-content: flex-end; gap: 11px">
          <v-btn v-for="index in 2" fab :key="index" @click="index === 1 ? testimonyPrev() : testimonyNext()"
            class="btn-mobile-slider-corp" elevation="0">
            <ArrowIcon style="color: white" :direct="index === 1 ? 'right' : 'left'" />
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <div class="form-konsultasi" style="padding: 0px 30px">
      <div class="header text-center mt-10">
        <h2 style="margin: 0;">
          {{ $t('corporateTraining.formSection.title') }}
        </h2>
      </div>
      <div class="sub-h text-center mt-2">
        <p style="margin: 0; font-size: 13px;">{{ $t('corporateTraining.formSection.subTitle') }}</p>
        <v-form class="text-start" style="margin-top: 60px" id="collab_training">
          <div>
            <label class="form-label" for="company">{{ $t('corporateTraining.formSection.labels.companyName') }}<span
                style="color: rgba(184, 15, 10, 1)">*</span></label>
            <v-text-field class="form-input text-form" name="company" v-model="form.corporate_name" outlined
              :placeholder="$t('corporateTraining.formSection.placeholders.companyName')"
              :full-width="true"></v-text-field>
          </div>
          <div>
            <label class="form-label" for="website">{{ $t('corporateTraining.formSection.labels.website') }}<span
                style="color: rgba(184, 15, 10, 1)">*</span></label>
            <v-text-field class="form-input text-form" name="website" v-model="form.web_url" outlined
              :placeholder="$t('corporateTraining.formSection.placeholders.website')"></v-text-field>
          </div>
          <div>
            <label class="form-label" for="pic-name">{{ $t('corporateTraining.formSection.labels.picName') }}<span
                style="color: rgba(184, 15, 10, 1)">*</span></label>
            <v-text-field class="form-input text-form" name="pic-name" outlined v-model="form.full_name"
              :placeholder="$t('corporateTraining.formSection.placeholders.picName')"></v-text-field>
          </div>
          <div>
            <label class="form-label" for="email">{{ $t('corporateTraining.formSection.labels.email') }}<span
                style="color: rgba(184, 15, 10, 1)">*</span></label>
            <v-text-field class="form-input text-form" name="email" outlined v-model="form.email"
              :placeholder="$t('corporateTraining.formSection.placeholders.email')" max-width></v-text-field>
          </div>
          <div>
            <label class="form-label" for="occupation">{{ $t('corporateTraining.formSection.labels.occupation')
              }}</label>
            <v-text-field class="form-input text-form" name="occupation" outlined v-model="form.job_pic"
              :placeholder="$t('corporateTraining.formSection.placeholders.occupation')">
            </v-text-field>
          </div>
          <div>
            <label class="form-label" for="phone-number">{{ $t('corporateTraining.formSection.labels.phoneNumber')
              }}<span style="color: rgba(184, 15, 10, 1)">*</span></label>
            <v-text-field class="form-input text-form" name="phone-number" outlined
              :placeholder="$t('corporateTraining.formSection.placeholders.phoneNumber')" type="number"
              v-model="form.phone_number" hide-spin-buttons>
              <template v-slot:prepend-inner>
                <img src="/img/other/flag-indonesia.png" alt="" width="30" height="20"
                  style="box-shadow: 2px 2px 3px 1px rgba(13, 28, 113, 0.1)" />
                <span style="color: #575966" class="mx-3">+62</span>
              </template>
            </v-text-field>
          </div>
          <div cols="12" class="form-collab">
            <label class="form-label" for="collaboration">{{
              $t('corporateTraining.formSection.labels.collaborationType')
              }}</label>
            <v-text-field class="form-input text-form" solo flat background-color="rgba(247, 249, 253, 1)"
              :placeholder="$t('corporateTraining.formSection.placeholders.collaborationType')" disabled />
          </div>
          <v-row>
            <v-col cols="6">
              <label class="form-label" for="program-category">{{ $t('corporateTraining.formSection.labels.category')
                }}<span style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-select class="form-input text-form" outlined v-model="program" :items="programTabs"
                :item-text="'title'" :item-value="'value'" @change="getCourseMaterial"
                :placeholder="$t('corporateTraining.formSection.placeholders.category')" />
            </v-col>
            <v-col cols="6">
              <label class="form-label" for="program-category">{{ $t('corporateTraining.formSection.labels.program')
                }}<span style="color: rgba(184, 15, 10, 1)">*</span></label>
              <v-select class="form-input text-form" v-model="form.program" outlined :items="courseMaterial"
                :item-text="'title'" :item-value="'title'"
                :placeholder="$t('corporateTraining.formSection.placeholders.program')" />
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center align-center mt-3">
            <v-checkbox class="form-input custom-checkbox" v-model="is_confirm">
              <template v-slot:label>
                <h5 style="font-size: 12px" class="label-checkbox"
                  v-html="`${$t('corporateTraining.formSection.labels.confirmCheckbox')}`"></h5>
              </template>
            </v-checkbox>
          </v-row>
          <v-row class="d-flex justify-center align-center mt-6">
            <v-btn elevation="0" :class="`btn-kirim ${is_confirm ? 'confirm' : 'reject'}`" @click="onSubmit">{{
              $t('corporateTraining.formSection.buttons.submit') }}
            </v-btn>
          </v-row>
        </v-form>
      </div>
    </div>
    <div class="faq" style="margin-top: 60px">
      <div class="content">
        <div class="row">
          <div class="col-lg-3">
            <div class="header">
              <h1>Frequently Asked Question</h1>
            </div>
          </div>
          <div class="container">
            <AccordeonFaq v-for="(item, index) in questions" :key="index" :title="item.title"
              :description="item.description" :active="item.active" @toggle="toggleAccordion(index, item.title)" />
          </div>
          <div class="btn-stoke-blue cursor-pointer mt-5" @click="goToFaq">
            <span class="font-poppins" style="color: #162ca2">{{ $t('corpAceleration.faqSection.viewMore') }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Popup from "@/components/others/Popup.vue";
import ArrowIcon from "@/assets/icons/Arrow.vue";
import MessageIcon from "@/components/ilustration/MessageIcon.vue";
import StepCollaborationMobile from "../../StepCollaborationMobile.vue";
import AccordeonFaq from "@/components/AccordeonFaq.vue";

export default {
  name: "MobileCorporateTraining",
  components: {
    Popup,
    ArrowIcon,
    MessageIcon,
    StepCollaborationMobile,
    AccordeonFaq
  },
  data() {
    return {
      program: 0,
      programLength: 2,
      programTabs: [
        {
          id: 1,
          title: "General Corp. Training Program",
          value: 0,
        },
        {
          id: 2,
          title: "Certified Corp. Training Program",
          value: 1,
        },
      ],
      partners: [],
      portfolios: [],
      courseMaterial: [],
      kemitraan: 0,
      alertErrMessage: "",
      isAlertErr: false,
      isError: false,
      testimonyModel: 0,
      portfoliosModel: 0,
      partnerModel: 0,
      indicatorValueTestimony: 0,
      sliderIndicatorTestimony: 0,
      indicatorValuePortfolios: 0,
      sliderIndicatorPortfolios: 0,
      indicatorValuePartner: 0,
      sliderIndicatorPartner: 0,
      dataMitra: [],
      testimony: [],
      questions: [],
      showDesc: [],
      is_confirm: false,
      form: {
        full_name: "",
        email: "",
        phone_number: "",
        gender: "",
        corporate_name: "",
        company_field: "",
        program: "",
        total_student: 0,
        notes: "",
        category: "TRAINING",
        web_url: "",
        job_pic: "",
      },
    };
  },
  watch: {
    program() {
      this.getCourseMaterial();
    },
    "$i18n.locale"() {
      this.getTestimoni();
      this.getMitra();
      this.getCourseMaterial();
      this.getPortofolio();
      this.getFaq();
    },
  },
  methods: {
    chooseTab(item) {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: `Select Program Tab - ${item.title} - Mobile Corporate Training`,
        value: 1,
      });
      this.program = item.value;
    },
    swipeLeft() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Swipe Left - Program Tabs - Mobile Corporate Training',
        value: 1,
      });
      if (this.program < this.programLength - 1) {
        this.program++;
      }
    },
    swipeRight() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Swipe Right - Program Tabs - Mobile Corporate Training',
        value: 1,
      });
      if (this.program > 0) {
        this.program--;
      }
    },
    kemitraanNext() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Next Collaboration Step - Mobile Corporate Training',
        value: 1,
      });
      this.kemitraan =
        this.kemitraan + 1 === this.steps.length ? 0 : this.kemitraan + 1;
    },
    kemitraanPrev() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Previous Collaboration Step - Mobile Corporate Training',
        value: 1,
      });
      this.kemitraan =
        this.kemitraan - 1 < 0 ? this.steps.length - 1 : this.kemitraan - 1;
    },
    testimonyNext() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Testimony Next - Mobile Corporate Training',
        value: 1,
      });
      if (this.testimonyModel < this.testimony.length - 1) {
        this.testimonyModel += 1;
        this.indicatorValueTestimony += this.sliderIndicatorTestimony + 50;
      }
      if (this.indicatorValueTestimony === 100) {
        return;
      }
    },
    testimonyPrev() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Testimony Previous - Mobile Corporate Training',
        value: 1,
      });
      if (this.testimonyModel > 0) {
        this.testimonyModel -= 1;
      }
      if (this.indicatorValueTestimony === 0) {
        return;
      }
      this.indicatorValueTestimony -= this.sliderIndicatorTestimony + 50;
    },
    PortfoliosNext() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Portfolio Next - Mobile Corporate Training',
        value: 1,
      });
      if (this.portfoliosModel < this.portfolios.length - 1) {
        this.portfoliosModel += 1;
        this.indicatorValuePortfolios += this.sliderIndicatorPortfolios + 50;
      }
      if (this.indicatorValuePortfolios === 100) {
        return;
      }
    },
    PortfoliosPrev() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Portfolio Previous - Mobile Corporate Training',
        value: 1,
      });
      if (this.portfoliosModel > 0) {
        this.portfoliosModel -= 1;
      }
      if (this.indicatorValuePortfolios === 0) {
        return;
      }
      this.indicatorValuePortfolios -= this.sliderIndicatorPortfolios + 50;
    },
    PartnersNext() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Partner Next - Mobile Corporate Training',
        value: 1,
      });
      if (this.partnerModel < this.dataMitra.length - 1) {
        this.partnerModel += 1;
        this.indicatorValuePartner += this.sliderIndicatorPartner + 50;
      }
      if (this.indicatorValuePartner === 100) {
        return;
      }
    },
    PartnersPrev() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'Partner Previous - Mobile Corporate Training',
        value: 1,
      });
      if (this.partnerModel > 0) {
        this.partnerModel -= 1;
      }
      if (this.indicatorValuePartner === 0) {
        return;
      }
      this.indicatorValuePartner -= this.sliderIndicatorPartner + 50;
    },
    slicedTestimony(index) {
      return [this.testimony[index]];
    },
    async getPortofolio() {
      try {
        const resp = await this.$http.get(
          `/v1/project-portfolio?category=TRAINING&is_main=true`
        );
        this.portfolios = resp.data.data.project_portfolios;
        this.sliderIndicatorPortfolios =
          100 / resp.data.data.project_portfolios.length + 4;
      } catch (err) {
        console.log(err);
      }
    },
    async getMitra() {
      try {
        const resp = await this.$http.get(`/v1/partner?category=TRAINING&page=1&per_page=9`);
        this.dataMitra = resp.data.data.partners;
        this.sliderIndicatorPartner = 100 / resp.data.data.partners.length + 8;
      } catch (err) {
        console.log(err);
      }
    },
    async getTestimoni() {
      try {
        const resp = await this.$http.get(
          `/v1/testimony?category=TRAINING&page=1&per_page=3`
        );
        this.testimony = resp.data.data.testimonies;
      } catch (err) {
        console.log(err);
      }
    },
    async getClientLogo() {
      try {
        const resp = await this.$http.get("/v1/logo?category=TRAINING");
        this.partners = resp.data.data.logos;
      } catch (err) {
        console.log(err);
      }
    },
    async getCourseMaterial() {
      try {
        const resp = await this.$http.get(`/v1/corporate-training?category=${this.program ? "CERTIFIED" : "GENERAL"}`);
        this.courseMaterial = resp.data.data.corporate_trainings;
        this.form.program = "";
      } catch (error) {
        console.log(error);
      }
    },
    toggleAccordion(index, title) {
      this.$gtag.event('click', {
        event_category: 'FAQ',
        event_label: `Toggle FAQ - ${title} - Mobile Corporate Training`,
        value: 1,
      });
      this.questions[index].active = !this.questions[index].active;
    },
    async getFaq() {
      this.questions = [];
      try {
        const resp = await this.$http.get(`/v1/faq?category=ACCELERATION&is_main=true`);
        this.questions = resp.data.data.faq.map((item) => ({
          description: item.answer[0],
          title: item.question,
          active: false,
        }));
      } catch (err) {
        console.log(err);
      }
    },
    sendToWa() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Contact Us - WhatsApp - Mobile Corporate Training',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    sendToWaConsultation() {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Consultation - WhatsApp - Mobile Corporate Training',
        value: 1,
      });
      window.open(
        "https://api.whatsapp.com/send/?phone=6282127274632&text=Hi%20Kak%20HiColleagues,%20saya%20mau%20bertanya",
        "_blank"
      );
    },
    scrollToSection(sectionId) {
      this.$gtag.event('click', {
        event_category: 'Button',
        event_label: 'Collaborate Now - Scroll to Form - Mobile Corporate Training',
        value: 1,
      });
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    goToFaq() {
      this.$gtag.event('click', {
        event_category: 'Navigation',
        event_label: 'View More FAQs - Mobile Corporate Training',
        value: 1,
      });
      this.$router.push('/faq');
    },
    async onSubmit() {
      this.$gtag.event('click', {
        event_category: 'Form',
        event_label: 'Submit Corporate Training Form - Mobile',
        value: 1,
      });
      if (!this.is_confirm) {
        return;
      }
      if (
        !this.form.corporate_name ||
        !this.form.full_name ||
        !this.form.job_pic ||
        !this.form.email ||
        !this.form.phone_number ||
        !this.form.category ||
        !this.form.web_url
      ) {
        this.alertErrMessage = "Harap isi semua form yang tersedia";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Corporate Training Form Submission Error - Mobile',
          value: 0,
        });
        return;
      }
      try {
        await this.$http.post("/v1/corporate-registration", this.form);
        this.alertErrMessage = "Success";
        this.isAlertErr = true;
        this.isError = false;
        this.clearForm();
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Corporate Training Form Submission Success - Mobile',
          value: 1,
        });
      } catch {
        this.alertErrMessage = "Error saat submit data";
        this.isAlertErr = true;
        this.isError = true;
        this.$gtag.event('form_submission', {
          event_category: 'Form',
          event_label: 'Corporate Training Form Submission Error - Mobile',
          value: 0,
        });
      }
    },
    clearForm() {
      this.is_confirm = false;
      this.form.full_name = "";
      this.form.email = "";
      this.form.phone_number = "";
      this.form.corporate_name = "";
      this.form.category = "";
      this.form.web_url = "";
      this.form.job_pic = "";
      this.form.program = "";
      this.notes = "";
      this.program = "";
    },
  },
  mounted() {
    this.getFaq();
    this.getTestimoni();
    this.getClientLogo();
    this.getCourseMaterial();
    this.getPortofolio();
    this.getMitra();
    this.$gtag.pageview(this.$route);
  },
  beforeMount() {
    this.sliderIndicatorTestimony = 37;
  },
};
</script>

<style src="./corporateTraining.css" scoped></style>